import React from 'react';
import { trackEvent } from '@99designs/tracking';
import { HeadingLink } from '../../../../shared/components/Link';
import scrollToElement from '../../../../shared/lib/scrollToElement';

interface Props {
    link: Link;
    categoryKey: string;
    isActive: boolean;
}

interface Link {
    title: string;
    href: string;
    key: string;
    scrollOffset: number;
}

export default function NavHeadingLink({ link, categoryKey, isActive }: Props) {
    return (
        <HeadingLink
            href={link.href}
            type="h5"
            onClick={(e) => {
                e.preventDefault();
                trackEvent('Clicked Sticky Nav Item on Product Page', {
                    category: categoryKey,
                    name: link.key,
                });
                const element = document.querySelector(link.href);
                if (element) {
                    scrollToElement(element, link.scrollOffset);
                }
            }}
            isActive={isActive}
        >
            {link.title}
        </HeadingLink>
    );
}
